import { FormattedMessage } from 'components/Commons/Translation'
import { HOME } from 'routes'

import { Container, Title, Message, Button } from './styled'

import translations from './translations'

function Local({ title, message, retry, goToHome = false }) {
  return (
    <Container data-testid="message_error_occured">
      <Title>
        <FormattedMessage {...title} />
      </Title>
      <Message>
        <FormattedMessage {...message} />
      </Message>
      {retry ? (
        <Button onClick={() => retry()}>
          <FormattedMessage {...translations.retry} />
        </Button>
      ) : goToHome ? (
        <Button href={`${window.location.origin}${HOME()}`}>
          <FormattedMessage {...translations.homepage} />
        </Button>
      ) : null}
    </Container>
  )
}

export default Local
